// import { auditStatus } from 'json/new-to-old-audit'
export let manualRewardLabels = [{
  label: '奖励发放流水号',
  value: 'number'
},
{
  label: '事业部归属',
  value: 'businessDepartmentName'
},
{
  label: '奖励类别',
  value: 'reward_type'
},
{
  label: '生命银行用户',
  value: 'extendInformation.firstName'
},
{
  label: '导入用户姓名',
  value: 'excelImportUserName'
},
{
  label: 'C端手机号',
  value: 'extendInformation.mobile'
},
{
  label: '平台注册时间',
  value: 'extendInformation.register_date'
},
{
  label: '返现',
  value: 'reward_money'
},
{
  label: '返券',
  value: 'couponTotalAmount'
},
{
  label: '发放时间',
  value: 'created_date'
}
  //   {
  //     label: '状态',
  //     value: 'audit_status'
  //   }
]
export let awardStatusTabs = [{
  label: '全部列表',
  value: 'ALL'
},
{
  label: '待初审',
  value: 'WAITING_FOR_APPROVAL'
},
{
  label: '待财务审核',
  value: 'SALES_COMPLETED'
},
{
  label: '已完成',
  value: 'COMPLETED'
},
{
  label: '客服已驳回',
  value: 'SALES_REJECTED'
},
{
  label: '财务已驳回',
  value: 'REJECTED'
}
]
export let filterLabels = [{
  label: '发放时间',
  type: 'time-slot',
  startName: 'dateStart', // 返回数据时，开始时间的字段名
  endName: 'dateEnd', // 返回数据时，结束时间的字段名
  value: 'grantDate'
},
{
  label: '发放金额',
  type: 'price-slot',
  clearable: true,
  minName: 'moneyRangeStart',
  maxName: 'moneyRangeEnd',
  value: 'grantMoney'
}
]
